import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { FETCH_SHORT_CODE_STATUS } from 'actions/auth';

const INITIAL_STATE = Immutable({
  loading: false,
  error: null,
  data: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${FETCH_SHORT_CODE_STATUS}_LOADING`:
      return state.merge({ loading: true, data: null });
    case `${FETCH_SHORT_CODE_STATUS}_ERROR`:
      return state.merge({ loading: false, error: action.payload });
    case FETCH_SHORT_CODE_STATUS:
      return state.merge({
        loading: false,
        error: null,
        data: true,
      });
    default:
      return state;
  }
};
